import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/pages/HomePage'
import TextBeautifierPage from '@/components/pages/TextBeautifierPage'
import HtmlToDokuWikiPage from '@/components/pages/HtmlToDokuWikiPage'
import HebrewReverseGematriaPage from '@/components/pages/HebrewReverseGematriaPage'
import HebrewTransliterationPage from '@/components/pages/HebrewTransliterationPage'
import GreekTransliterationPage from '@/components/pages/GreekTransliterationPage'
import DictionaryPage from '@/components/pages/DictionaryPage'
import VocabularyPage from '@/components/pages/VocabularyPage'
import MemorizationToolPage from '@/components/pages/MemorizationToolPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/text-beautifier',
      name: 'text_beautifier',
      component: TextBeautifierPage
    },
    {
      path: '/html-to-dokuwiki',
      name: 'html_to_dokuwiki',
      component: HtmlToDokuWikiPage
    },
    {
      path: '/hebrew/transliteration-gematria',
      name: 'hebrew_transliteration',
      component: HebrewTransliterationPage
    },
    {
      path: '/hebrew/reverse-gematria',
      name: 'hebrew_reverse_gematria',
      component: HebrewReverseGematriaPage
    },
    {
      path: '/greek/transliteration-gematria',
      name: 'greek_transliteration',
      component: GreekTransliterationPage
    },
    {
      path: '/vocabulary',
      name: 'vocabulary',
      component: VocabularyPage
    },
    {
      path: '/english-dictionary',
      name: 'dictionary',
      component: DictionaryPage
    },
    {
      path: '/memorization-tool',
      name: 'memorization_tool',
      component: MemorizationToolPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js